export default __webpack_public_path__ + "static/media/Spotify_Icon.cd66b8f6.png";